module.exports = __webpack_public_path__ + "static/media/btn_paypay63a08918341a28a29daef6cad8183a37.webp";